export interface OfferAlert {
    function: string | number;
    province: number;
    cities?: Array<number>;
    frequency: JobAlertFrequency;
}

export enum JobAlertFrequency {
    DIARY = 2,
    WEEKLY = 3,
    NEVER = 1
  }
  